import React from "react";
import GlobalProvider from "./context/GlobalContext";

import Layout from "./routes/App";
import ErrorBoundary from "./components/Common/Error";

const ClientApp = ({ authed }) => {
  return (
    <GlobalProvider>
      <ErrorBoundary>
        <Layout authed={authed} />
      </ErrorBoundary>
    </GlobalProvider>
  );
};


export default ClientApp
